import React from 'react'
import SelectBox from '../common/SelectBox'

class SellingHome extends React.Component {
  render() {
    const {
      checked,
      onChange,
      disabled,
    } = this.props

    return(
      <div>
        <div className='mb-3' />
        <div className='grey smaller mb-2'>Do you intend to sell your current home to fund the new purchase?</div>
        <SelectBox
          disabled={ disabled }
          checked={ checked === true }
          name='sell-current-home'
          value={ true }
          text='Yes'
          style='d-inline-block'
          onChange={ onChange }
        />
        <SelectBox
          disabled={ disabled }
          checked={ checked === false }
          name='sell-current-home'
          value={ false }
          text='No'
          style='d-inline-block'
          onChange={ onChange }
        />
      </div>
    )
  }
}

export default SellingHome;
